import _ from 'underscore';
import BasicInspectorNodeParamView from "views/audioEditor/sequencerNodeInspectorSection/paramView/BasicInspectorNodeParamView";
import SubTitleParamTemplate from 'text!../../../../../templates/audioEditor/sequencerNodeInspectorSection/paramView/SubTitleParamTemplate.html';


const SubTitleParamView = BasicInspectorNodeParamView.extend({

    constructor : function(attributes, options) {
        BasicInspectorNodeParamView.apply(this, [attributes, options]);
        this.compiledTemlate =  _.template(SubTitleParamTemplate);
    },			
    

    updateViewOnValueChange : function(newValue){
        if(this.titleLabel$el){
            this.titleLabel$el.html(newValue);
        }
    },

    render : function(){
        this.$el.html(this.compiledTemlate({ "viewObj": this}));
        this.setElement(this.$el.find(".basic_inpector_param_view").first());
        this.titleLabel$el = this.$el.find(".sub_title_label");
    }

});
export default SubTitleParamView;